import { AbstractControl } from '@angular/forms';

export class PhoneHelper {
  static formatToBrazilianMobile(value: string | null | undefined): string {
    if (!value) return '';

    let v = value.replace(/\D/g, '');

    if (v.length <= 2) {
      return '';
    }

    if (!v.startsWith('55')) {
      v = '55' + v;
    }

    if (v.length > 13) {
      v = v.substring(0, 13);
    }

    let formatted = '+55';

    if (v.length > 2) {
      formatted += ` (${v.substring(2, 4)}`;
    }

    if (v.length > 4) {
      formatted += `) `;
      const numero = v.substring(4);

      if (numero.length <= 4) {
        formatted += numero;
      } else if (numero.length <= 8) {
        formatted += `${numero.substring(0, 4)}-${numero.substring(4)}`;
      } else {
        formatted += `${numero.substring(0, 5)}-${numero.substring(5)}`;
      }
    }

    return formatted;
  }

  static cleanForApi(value: string | null | undefined): string | null {
    if (!value) return null;

    const digits = value.replace(/\D/g, '');

    if (!digits) return null;

    return '+' + digits;
  }

  static applyPhoneMaskOnInit(control: AbstractControl) {
    const initial = control.value;

    if (initial) {
      const formatted = this.formatToBrazilianMobile(initial);
      control.setValue(formatted, { emitEvent: false });
    }

    control.valueChanges.subscribe((value: string) => {
      const formatted = this.formatToBrazilianMobile(value);

      if (value !== formatted) {
        control.setValue(formatted, { emitEvent: false });
      }
    });
  }
}
